<style scoped lang="scss">
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
@import '@zz-common/zz-ui/lib/style/mixins/ellipsis.scss';

.service-guide {
  padding-top: 12px;
  .service-guide-top {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    box-sizing: border-box;
    height: 98px;
    padding-right: 32px;

    .img-service {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      width: 100%;
      img {
        width: 100%;
        height: 100%;
      }
      span {
        position: absolute;
        top: calc(35% + 1px);
        left: 212px;
        color: #ffffff;
        font-weight: 300;
        font-size: 22px;
        font-family: PingFangSC, PingFang SC;
        line-height: 24px;
      }
    }
  }
  .service-guide-wrapper {
    display: flex;
    margin-top: -1px;
    padding: 11px 0;
    background-color: #f8f8f8;
    border-radius: 0 0 16px 16px;

    .service-guide-title {
      width: 88px;
      color: #999;
      font-weight: 300;
      font-size: 22px;
      font-family: PingFangSC-Light, PingFang SC;
      line-height: 1;
      text-align: center;
    }
    .service-guide-content {
      position: relative;
      flex: 1;
      box-sizing: border-box;
      overflow: hidden;
      .content-list {
        display: flex;
        flex-wrap: wrap;
        .item-content {
          display: flex;
          align-items: center;
          margin: 0 32px 14px 0;
          font-weight: 300;
          font-size: 22px;
          font-family: PingFangSC-Light, PingFang SC;
          line-height: 1;
          .icon-service {
            position: relative;
            width: 20px;
            height: 20px;
            margin-top: -0.5px;
            margin-right: 8px;
          }
        }
      }

      .process-item {
        align-items: flex-start !important;
        color: #000;
        font-weight: 300;
        font-size: 24px;
        font-family: PingFangSC-Light, PingFang SC;
        line-height: 24px;
        .item_address {
          @include ellipsis();
          margin-bottom: 16px;
          color: #111;
          font-size: 24px;
          line-height: 28px;
          .title {
            margin-right: 24px;
          }
        }
        .item_info {
          @include multi-ellipsis(2);
          display: flex;
          align-items: center;
          color: #666;
          font-weight: 300;
          font-size: 22px;
          font-family: PingFangSC-Light, PingFang SC;
          line-height: 32px;
        }
      }
    }
    .icon_arrow {
      width: 24px;
      height: 24px;
      margin-top: 0;
      padding-right: 24px;
      line-height: 1;
    }
  }
  .bottom-content {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
<template>
  <div class="service-guide">
    <div
      v-zpm="{
        sectionid: 165,
        sortid: 0,
        sortname: '详情页心智条',
        backup: {
          postId: officialMindSetInfo.postId || ''
        }
      }"
      class="service-guide-top"
      @click="serviceGuideClick"
    >
      <img class="img-service" :src="$setPicSize(userThinkingImg)" alt="" />
    </div>
    <div class="service-guide-wrapper" @click="serviceClick">
      <div class="service-guide-title">{{ title }}</div>
      <div class="service-guide-content">
        <div class="content-list">
          <div v-for="(item, index) in service" :key="index" class="item-content">
            <img
              class="icon-service"
              :src="
                $setPicSize(
                  'https://pic3.zhuanstatic.com/zhuanzh/ceeb00bd-f18e-47c1-bfb2-973ecf3bfe6e.png'
                )
              "
              alt=""
            />
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>
      <img
        :src="
          $setPicSize(
            'https://pic2.zhuanstatic.com/zhuanzh/90003314-29ea-4062-9088-e3d392fc1b06.png'
          )
        "
        class="icon_arrow"
        alt=""
      />
    </div>

    <div class="bottom-content">
      <slot name="bottom"></slot>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { skipToUrl } from '@utils/native'
import { getQueryString } from '@utils'
import { state } from '@/store'
export default defineComponent({
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: '服务'
    }
  },
  setup(props) {
    // 官方验心智信息
    const officialMindSetInfo = computed(() => {
      return props.dataInfo?.officialMindSetInfo || {}
    })
    // 服务信息
    const service = computed(() => {
      return props.dataInfo?.serviceLogos || []
    })
    // 是否展示案例入口按钮
    const showRealCaseBtn = computed(() => {
      return props.dataInfo?.showRealCaseBtn || 0
    })
    // 客服链接
    const consultUrl = computed(() => {
      return props.dataInfo?.customerService?.consultUrl || ''
    })
    // 末级类目
    const cateLastId = computed(() => {
      return props.dataInfo?.cateLastId || ''
    })

    /**
     * $ 是否是7天无理由商品
     * POP： 20200210951027001 已验机：201909261637001 找靓机：2208250002
     */
    const sevenDay = ['20200210951027001', '201909261637001', '2208250002']
    const isReturnPolicy = computed(() => {
      return service.value.some((item) => sevenDay.includes(item.labelId))
    })

    /**
     * $ 商详类型 暂且区分 二奢 | 卖场
     */
    // TODO: 二奢融合 官网验心智 是否是二奢的心智条
    const infoType = computed(() => {
      return props.dataInfo?.infoType
    })

    /**
     * $ 官方验心智图片
     * // 1-老B2C一机一拍 2-二奢一机一拍
     */
    // TODO: 二奢融合 官网验心智图片 二奢判断与别处不同
    const userThinkingImg = computed(() => {
      if (officialMindSetInfo.value?.mindsetImgUrl) {
        return officialMindSetInfo.value.mindsetImgUrl
      }
      const imageUrlMap = {
        1000: {
          true: 'https://pic4.zhuanstatic.com/zhuanzh/4a2e13b8-ad3a-4786-94bd-d869a1b65aa0.png',
          false: 'https://pic3.zhuanstatic.com/zhuanzh/f9fe8a6c-3248-4315-8a67-464f98c3d8a0.png'
        },
        default: 'https://pic4.zhuanstatic.com/zhuanzh/300ad86b-d37a-46dc-9da5-2b9d1a768466.png'
      }
      return imageUrlMap[infoType.value]?.[isReturnPolicy.value] || imageUrlMap.default
    })

    /**
     * $ 打开官方验介绍详情
     */
    const serviceGuideClick = () => {
      const luxuryTargetUrl =
        'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/65642f18a67216007f487db0/index.html?magicplatform=zz&needHideHead=3&needNewWebview=2&activeTabIdx=5&wvHalfVer=v2&wvHeightRate=0.8&wvCornerRadius=32'

      const targetUrl =
        officialMindSetInfo.value?.articleJumpUrl ||
        'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/64db39504a24dc006a1b7752/index.html?magicplatform=zz&needNewWebview=1'
      skipToUrl({
        targetUrl: infoType.value != 1000 ? luxuryTargetUrl : targetUrl
      })
    }

    /**
     * $ 打开官方验半层
     */
    const serviceClick = () => {
      const infoId = getQueryString('infoId') || state.infoId
      const targetUrl = `https://m.zhuanzhuan.com/u/micro_detail/servicePopup?needHideHead=3&wvCornerRadius=36&wvHalfVer=v2&wvHeightRate=0.8&infoId=${infoId}&type=1&showRealCaseBtn=${
        showRealCaseBtn.value
      }&cateGrandId=${cateLastId.value}&consultUrl=${encodeURIComponent(consultUrl.value)}`
      skipToUrl({
        targetUrl
      })
    }
    return {
      serviceGuideClick,
      serviceClick,
      service,
      isReturnPolicy,
      officialMindSetInfo,
      userThinkingImg
    }
  }
})
</script>
